/**************************************************
 * Nombre:       Catalogo_Lista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import Tarjeta_Producto_Home from "../../Tarjetas/Tarjeta_Producto_Home";
import linea from '../../../Recursos/Graficos/linea.svg'
import Tarjeta_Categorias_Catalogo from "../../Tarjetas/Tarjeta_Categorias_Catalogo";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {ArrowDropDown} from '@mui/icons-material'

const Catalogo_Lista = () => {
    const {sCell} = useResponsive()
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                {sCell ?

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: -3}}>
                        <Button
                            variant="text"
                            endIcon={<ArrowDropDown/>}
                        >
                            Order
                        </Button>
                    </Grid>
                    :
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 3}}
                        sx={{
                            p: 2
                        }}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Typography sx={{fontWeight: 600, fontSize: 18, lineHeight: 1.3}}>Categorias de
                                <br/>
                                Productos</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <img src={linea} width={'70%'} height={10}/>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={0.5}
                            sx={{mt: 2}}
                        >

                            {categorias.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Categorias_Catalogo item={item}/>
                                </Grid>
                            ))}

                        </Grid>

                    </Grid>
                }


                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 9}}
                    spacing={3}
                >

                    {items.map((item, index) => (
                        <Grid container size={{xs: 6, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Producto_Home/>
                        </Grid>
                    ))}

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Catalogo_Lista

const items = [1, 2, 3, 4, 5]

const categorias = ['GAFAS HOMBRE', 'GAFAS MUJER', 'GAFAS MUJER', 'GAFAS MUJER'];